import React from "react";
import { motion } from "framer-motion";

const ImageGallery = ({images}) => {
  return (
    <div className="grid grid-cols-3 gap-4 md:grid-cols-4 lg:grid-cols-6">
      {images.map((img, index) => (
        <motion.div
          key={index}
          className={`overflow-hidden ${img.className}`}
          
        >
          <img
            src={img.src}
            alt={`Gallery ${index}`}
            className="w-full h-full object-cover "
          />
        </motion.div>
      ))}
    </div>
  );
};

export default ImageGallery;
